module.exports = __webpack_public_path__ + "static/media/minihan_hicks_weiss_turner_minihan_marshall.17008b32.jpg";